import ynToBool from "Utils/ynToBool";

export const ga4DecryptionEndpoint = process.env.REACT_APP_AUTH_ENDPOINT;
export const ga4Container = process.env.REACT_APP_GA4_CONTAINER;
export const ga4HasCrossDomains = ynToBool(process.env.REACT_APP_GA4_CROSSDOMAINS);
export const ga4Domains = process.env.REACT_APP_GA4_DOMAINS;
